import { getRequest, postRequest, putRequest } from '@/core/http-methods';
import {
  attachmentResponse,
  PostCommentErrorStatus,
  TaskCommentReceived,
  PostCommentError,
} from '@/domain/task';
import { IhttpResponse } from '@/interfaces/http-interfaces';
import { CredentialsError, BackendError } from '../errors/api_errors';
import globalStore from '../store/globalStore';

const TASK_COMMENT_URL = `${
  import.meta.env.VITE_RADAR_URL
}/async/comment/task/`;

export const commentTask = async (
  id: number,
  value: TaskCommentReceived
): Promise<PostCommentError> => {
  const url = `${TASK_COMMENT_URL}${id}`;
  const body = value;
  const res: IhttpResponse = await postRequest(url, body);
  if (res.status === 200) {
    return res;
  }
  if (res.status === 401) {
    throw new CredentialsError(JSON.stringify(res.status));
  }
  throw new BackendError(res.body);
};

export const postAttachment = async (
  value: File
): Promise<attachmentResponse> => {
  const url = `${import.meta.env.VITE_RADAR_URL}/task/attachments`;
  const body = {
    file: value,
  };

  const headers = {
    'Content-Type': 'multipart/form-data',
  };

  const res: IhttpResponse = await postRequest(url, body, headers);
  if (res.status === 200) {
    return res.body as attachmentResponse;
  }
  if (res.status === 401) {
    throw new CredentialsError(JSON.stringify(res.body));
  }
  throw new BackendError(res.body);
};

export const getUnreadTaskCounter = async () => {
  const url = `${import.meta.env.VITE_RADAR_URL}/comment/get-unread-counters`;

  const res: IhttpResponse = await getRequest(url);
  if (res.status === 200) {
    globalStore.commit('setUnreadTaskCounter', res.body);
    return res.body;
  }

  if (res.status === 401) {
    throw new CredentialsError(JSON.stringify(res.body));
  }

  throw new BackendError(res.body);
};

export const putComment = async (
  commentId: number,
  body: { text: string; attachment_ids: number[] }
) => {
  const url = `${import.meta.env.VITE_RADAR_URL}/comment/${commentId}`;
  const res: IhttpResponse = await putRequest(url, body);
  if (res.status === 200) {
    return res.body;
  }

  if (res.status === 401) {
    throw new CredentialsError(JSON.stringify(res.body));
  }

  throw new BackendError(res.body);
};
